import axios from "axios";
import Vue from 'vue'
import {LoadingService} from "../components/loading"
import {contentType, requestTimeout} from "@/config/settings";
import router from "@/router";

Vue.use(LoadingService)
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: requestTimeout,
    withCredentials: false,
    crossDomain: true,
    headers: {
        "Content-Type": contentType,
        "clientId": "pc"
    },
});
service.interceptors.request.use(config => {
        Vue.prototype.$vloading.show();
        if (sessionStorage.getItem('accessToken')) {
            config.headers.Authorization = 'Bearer ' + sessionStorage.getItem('accessToken')
        }
        return config;
    },
);

service.interceptors.response.use((response) => {
        Vue.prototype.$vloading.hide();
        const {status, data, config} = response;
        const {msg} = data;
        if (status !== 200) {
            console.info("http error:" + config.url + status + msg);
            router.push({path: "/error"});
            return null;
        }
        return data;
    },
    error => {
        Vue.prototype.$vloading.hide();
        const {data} = error.response;
        if(data.code){
            if(data.code === 203){
                sessionStorage.setItem("httpErrorMsg","账户在别处登录，或账户信息被更新。");
                router.push({path: "/login"});
                return null;
            }
        }
        router.push({path: "/error"});
        return null;
    }
);
export default service;
